import { RequestNewsDetailByName } from "../dtos/news/detail";
import { RequestNewsCount, RequestNewsList } from "../dtos/news/summary";
import Server from "./index";

export default class NewsServer extends Server {
  constructor() {
    super("/news.php");
  }

  public get(
    params: RequestNewsCount | RequestNewsList | RequestNewsDetailByName
  ): Promise<any> {
    return super.get(params);
  }
}
